import { useMutation } from '@tanstack/react-query';
import { adminServices } from '../../../Domain/Admin/Services';
import type { UsageInvoicingExportParams } from '../../../Domain/Admin/Services';

const mutationFn = (params: UsageInvoicingExportParams) => {
  return adminServices.exportUsageInvoicing(params);
};

export const useUsageInvoicingExportMutation = () => {
  return useMutation<
    Awaited<ReturnType<typeof adminServices.exportUsageInvoicing>>,
    unknown,
    UsageInvoicingExportParams
  >(mutationFn);
};
